// extracted by mini-css-extract-plugin
export default {"tags_reads_arc":"TagReadsArc_tags_reads_arc__d2oE6"};